<meta charset="utf-8">

<app-main-nav>
    <router-outlet></router-outlet>
</app-main-nav>

<script type="text/javascript" src="/node_modules/ng-openseadragon/dist/ng-openseadragon.min.js"></script>